module.exports = __webpack_public_path__ + "img/map_hastext.aac2047c.png";